(() => {
'use strict';
const qs = (root, selector) => root.querySelector(selector);
const all = (root, selector) => Array.from(root.querySelectorAll(selector));

function catalogue(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const cards = all(root, '[data-wb-card]').map(el => ({
    el,
    variants: JSON.parse(el.dataset.variants),
    links: all(el, '[data-product-link]').map(link => ({link, original: link.getAttribute('href')}))
  }));
  const filters = all(root, '[data-filter]');
  const disclosure = qs(root, '[data-filter-disclosure]');
  const wideScreen = window.matchMedia('(min-width: 701px)');
  if (disclosure) {
    disclosure.open = wideScreen.matches;
    wideScreen.addEventListener('change', event => {disclosure.open = event.matches;});
  }
  const update = () => {
    const f = Object.fromEntries(filters.map(x => [x.dataset.filter, x.value]));
    const active = filters.filter(filter => filter.value.trim() !== (filter.dataset.defaultValue || '')).length;
    const activeCount = qs(root, '[data-filter-count]');
    if (activeCount) activeCount.textContent = active ? '(' + active + ' active)' : '';
    qs(root, '[data-reset]').hidden = active === 0;
    let count = 0;
    cards.forEach(({el, variants, links}) => {
      const d = el.dataset;
      const variant = variants.find(v => (!f.size || v.size === f.size) && (!f.colour || v.colour === f.colour));
      const show = (!f.search || d.name.includes(f.search.trim().toLowerCase())) &&
        (!f.garment || d.garment === f.garment) &&
        (!f.tier ? d.tier !== 'rude' : d.tier === f.tier) &&
        (!f.occasion || d.occasion.split('|').includes(f.occasion)) && !!variant;
      el.hidden = !show;
      links.forEach(({link, original}) => {
        if (variant && (f.size || f.colour)) {
          const url = new URL(original, window.location.href);
          url.searchParams.set('variant', String(variant.id));
          link.setAttribute('href', url.pathname + url.search + url.hash);
        } else {
          link.setAttribute('href', original);
        }
      });
      if (show) count++;
    });
    qs(root, '[data-result]').textContent = count + ' garment' + (count === 1 ? '' : 's') + ' match your choices';
    qs(root, '[data-empty]').hidden = count !== 0;
  };
  filters.forEach(x => x.addEventListener(x.type === 'search' ? 'input' : 'change', update));
  qs(root, '[data-reset]').addEventListener('click', () => {
    filters.forEach(x => x.value = x.dataset.defaultValue || '');
    update();
    if (disclosure && !wideScreen.matches) qs(disclosure, 'summary').focus();
    else filters[0]?.focus();
  });
  ['garment', 'size', 'colour', 'occasion'].forEach(key => {
    const select = qs(root, '[data-filter="' + key + '"]');
    all(select, 'option').slice(1).forEach(option => {
      if (!cards.some(card => ['size', 'colour'].includes(key)
        ? card.variants.some(v => v[key] === option.value)
        : (key === 'occasion' ? card.el.dataset[key].split('|').includes(option.value) : card.el.dataset[key] === option.value))) option.remove();
    });
  });
  update();
}

function wall(root){if(root.dataset.ready)return;root.dataset.ready='1';const cards=all(root,'[data-design]');qs(root,'[data-wall-tier]').addEventListener('change',e=>{let count=0;cards.forEach(card=>{card.hidden=!!e.target.value&&card.dataset.tier!==e.target.value;if(!card.hidden)count++;});qs(root,'[data-wall-count]').textContent=count+' design'+(count===1?'':'s');});all(root,'[data-reveal]').forEach(button=>button.addEventListener('click',()=>{const card=button.closest('[data-design]');qs(card,'.wb-card__cover').hidden=true;qs(card,'.wb-card__content').hidden=false;qs(card,'a').focus();}));}

function gift(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const products = JSON.parse(qs(root, '[data-gift-products]').textContent);
  const mode = qs(root, '[data-gift-mode]'), rude = qs(root, '[data-gift-rude]');
  const submit = qs(root, '[data-gift-submit]'), status = qs(root, '[data-gift-status]');
  const slots = all(root, '[data-slot]').map(el => ({
    el, product: qs(el, '[data-product]'), size: qs(el, '[data-size]'), colour: qs(el, '[data-colour]'),
    image: qs(el, '[data-image]'), choice: qs(el, '[data-choice]')
  }));
  let busy = false;
  if (new URLSearchParams(window.location.search).get('pair') === 'vests') mode.value = 'vests';
  const label = type => type === 'Baby Vest' ? 'Baby vest' : type === 'Baby T-Shirt' ? 'Baby tee' : 'Kids’ tee';
  const options = (select, values, placeholder, previous = '') => {
    select.replaceChildren(new Option(placeholder, ''));
    values.forEach(([value, text]) => select.add(new Option(text, value)));
    select.value = values.some(([value]) => value === previous) ? previous : '';
  };
  const current = slot => products.find(p => String(p.id) === slot.product.value);
  const selected = slot => current(slot)?.variants.find(v => v.size === slot.size.value && v.colour === slot.colour.value);
  const clearStatus = () => {status.textContent = ''; status.classList.remove('wb-gift__error');};
  const refresh = () => {
    submit.disabled = busy || !slots.every(selected);
    slots.forEach(slot => {
      const p = current(slot), v = selected(slot);
      slot.choice.textContent = v ? p.name + ' · ' + label(p.type) + ' · ' + v.size + ' · ' + v.colour : '';
      if (p) {
        slot.image.hidden = false;
        slot.image.src = v?.image || p.image;
        slot.image.alt = p.name + ' ' + label(p.type) + (v ? ' in ' + v.colour : '');
      } else {
        slot.image.hidden = true;
        slot.image.removeAttribute('src');
      }
    });
  };
  const colours = (slot, previous = '') => {
    const p = current(slot);
    options(slot.colour, p ? [...new Set(p.variants.filter(v => v.size === slot.size.value).map(v => v.colour))].map(c => [c, c]) : [], 'Choose a colour', previous);
    slot.colour.disabled = !slot.size.value;
    refresh();
  };
  const sizes = (slot, previousSize = '', previousColour = '') => {
    const p = current(slot);
    options(slot.size, p ? [...new Set(p.variants.map(v => v.size))].map(size => [size, size]) : [], 'Choose a size', previousSize);
    slot.size.disabled = !p;
    colours(slot, previousColour);
  };
  const populate = event => {
    const eligible = products.filter(p => (mode.value === 'vests' ? p.type === 'Baby Vest' : ['Baby T-Shirt', 'Kids T-Shirt'].includes(p.type)) && (rude.checked || p.tier !== 'rude') && p.variants.length);
    const cleared = [];
    slots.forEach((slot, index) => {
      const previous = {product: slot.product.value, size: slot.size.value, colour: slot.colour.value};
      options(slot.product, eligible.map(p => [String(p.id), p.name + ' · ' + label(p.type)]), 'Choose a design and garment', previous.product);
      sizes(slot, slot.product.value ? previous.size : '', slot.product.value ? previous.colour : '');
      if (previous.product && !slot.product.value) cleared.push('Gift ' + (index + 1));
    });
    qs(root, '[data-gift-total]').textContent = mode.value === 'vests' ? 'Two vests: £32' : 'Two tees: £42';
    qs(root, '[data-gift-delivery]').textContent = (mode.value === 'vests' ? 'Standard GB delivery £4.99. Pair plus standard delivery: £36.99.' : 'Free standard GB delivery.') + ' Printed in 5-7 working days, then delivered in 3-5 working days after dispatch.';
    clearStatus();
    if (cleared.length) status.textContent = 'Choose a new design for ' + cleared.join(' and ') + (event?.target === rude && !rude.checked ? ' because rude designs are hidden.' : ' to match your new pair type.');
  };
  slots.forEach(slot => {
    slot.product.addEventListener('change', () => {clearStatus(); sizes(slot);});
    slot.size.addEventListener('change', () => {clearStatus(); colours(slot);});
    slot.colour.addEventListener('change', () => {clearStatus(); refresh();});
  });
  mode.addEventListener('change', populate);
  rude.addEventListener('change', populate);
  qs(root, '[data-gift-form]').addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !slots.every(selected)) return;
    busy = true;
    clearStatus();
    refresh();
    status.textContent = 'Adding your pair…';
    let added = false;
    try {
      const variants = slots.map(selected);
      const expected = mode.value === 'vests' ? 1700 : 2295;
      if (variants.some(v => v.price !== expected)) throw Error('A garment price has changed. Please check the product page before ordering.');
      const counts = new Map();
      variants.forEach(v => counts.set(v.id, (counts.get(v.id) || 0) + 1));
      const res = await fetch(root.dataset.root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [...counts].map(([id, quantity]) => ({id, quantity}))})
      });
      const result = await res.json();
      if (!res.ok) throw Error(result.description || 'The selected pair is unavailable. Choose another size or colour.');
      added = true;
      status.textContent = 'Both garments added. Opening your basket…';
      window.location.assign(root.dataset.root + 'cart');
    } catch (error) {
      status.textContent = added ? 'Your pair was added. Open your basket to review the order.' : error.message;
      status.classList.add('wb-gift__error');
      if (added) {
        const link = document.createElement('a');
        link.href = root.dataset.root + 'cart';
        link.textContent = ' View basket';
        status.append(link);
      }
    } finally {
      if (!added) {busy = false; refresh();}
    }
  });
  populate();
}

function boot(){all(document,'[data-wb-catalogue]').forEach(catalogue);all(document,'[data-wb-wall]').forEach(wall);all(document,'[data-wb-gift]').forEach(gift);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot);
})();
